module.exports = __webpack_public_path__ + "img/vertical_5_1_7016.5aa387e4.png";